<template>
    <div class="form-errors js-form-validation__errors vfb-errors" :class="className">
        <ul class="list-unstyled" v-if="errors?.length">
            <li v-for="(error, index) in errors" :key="index">{{ error.message }}</li>
        </ul>
    </div>
</template>

<script setup lang="ts">
interface Props {
  errors?: Error[];
  className?: string;
}

defineProps<Props>();
</script>